const clipboard = () => {
  const copyEmailBtn = document.querySelector('.js-clipboard');
  if (copyEmailBtn) {
    copyEmailBtn.addEventListener('click', () => {
      // Select the email link anchor text
      const text = document.querySelector('.js-clipboard-to-copy');

      const range = document.createRange();
      range.selectNodeContents(text);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      document.querySelector('.c-post__copy').style.display = 'block';
      setTimeout(() => {
        document.querySelector('.c-post__copy').style.display = 'none';
      }, 3000);
    });
  }
};
export default clipboard;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/bnppblog-chisel/src/scripts/modules/clipboard.js